(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[580],{

/***/ "4xwT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InsuranceCancellation", function() { return InsuranceCancellation; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var InsuranceCancellation = function InsuranceCancellation(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 28 25"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M14,.28C7.63,.28,2.45,5.46,2.45,11.83c0,.28,.22,.5,.5,.5s.5-.22,.5-.5c0-.79,1.31-1.66,3.18-1.66s3.18,.88,3.18,1.66c0,.28,.22,.5,.5,.5s.5-.22,.5-.5c0-.71,1.08-1.5,2.68-1.64v1.75c-.93,.18-1.66,.87-1.87,1.75h-3.78c-1.09,0-1.98,.89-1.98,1.98v7.06c0,1.09,.89,1.98,1.98,1.98h12.3c1.09,0,1.98-.89,1.98-1.98v-7.06c0-1.09-.89-1.98-1.98-1.98h-3.78c-.21-.88-.94-1.56-1.87-1.75v-1.75c1.6,.14,2.68,.92,2.68,1.64,0,.28,.22,.5,.5,.5s.5-.22,.5-.5c0-.79,1.31-1.66,3.18-1.66s3.18,.88,3.18,1.66c0,.28,.22,.5,.5,.5s.5-.22,.5-.5C25.55,5.46,20.37,.28,14,.28ZM6.63,9.17c-1.2,0-2.26,.3-3.02,.8C4.38,5.66,7.78,2.25,12.09,1.46c-1.28,1.73-2.04,5.14-2.23,8.68-.76-.59-1.91-.96-3.23-.96Zm11.31,5.53v9.02h-7.88V14.7h7.88ZM6.87,22.74v-7.06c0-.54,.44-.98,.98-.98h1.21v9.02h-1.21c-.54,0-.98-.44-.98-.98Zm14.26-7.06v7.06c0,.54-.44,.98-.98,.98h-1.21V14.7h1.21c.54,0,.98,.44,.98,.98Zm-5.81-1.98h-2.64c.22-.47,.73-.8,1.32-.8s1.1,.33,1.32,.8Zm-1.32-4.53c-1.26,0-2.37,.34-3.13,.89,.28-5.25,1.77-8.77,3.13-8.77s2.85,3.53,3.13,8.77c-.76-.55-1.87-.89-3.13-.89Zm7.37,0c-1.32,0-2.47,.37-3.23,.96-.19-3.54-.94-6.95-2.23-8.68,4.31,.79,7.71,4.2,8.48,8.52-.76-.5-1.82-.8-3.02-.8Z"
  }));
};

/***/ })

}]);